import { shapeBoundingRect2 } from "./util";
import { ShapeSizeable2 } from "./types/Shape";
import Rect from "./types/Rect";

export enum ArrangementAnchor {
  N = "N",
  W = "W",
}

function applyNArrangement<ShapeArrangeable extends ShapeSizeable2>(
  lastShapeBox: Rect,
  shape: ShapeArrangeable
): ShapeArrangeable {
  return {
    ...shape,
    boundingBoxOrigin: [lastShapeBox.minX, lastShapeBox.maxY],
  };
}

function applyWArrangement<ShapeArrangeable extends ShapeSizeable2>(
  lastShapeBox: Rect,
  shape: ShapeArrangeable
): ShapeArrangeable {
  return {
    ...shape,
    boundingBoxOrigin: [lastShapeBox.maxX, lastShapeBox.minY],
  };
}

export function applyArrangement<ShapeArrangeable extends ShapeSizeable2>(
  shapes: ShapeArrangeable[],
  arrangement: ArrangementAnchor
): ShapeArrangeable[] {
  if (!shapes.length) return [];
  let lastShapeBox = shapeBoundingRect2(shapes[0]);
  return shapes.map((oldShape, i) => {
    if (i === 0) return oldShape;
    const newShape = (function (): ShapeArrangeable {
      switch (arrangement) {
        case ArrangementAnchor.N:
          return applyNArrangement(lastShapeBox, oldShape);
        case ArrangementAnchor.W:
          return applyWArrangement(lastShapeBox, oldShape);
      }
    })();
    lastShapeBox = shapeBoundingRect2(newShape);
    return newShape;
  });
}
